import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div\n  class=\"bb-toggle {{if @value \'bb-toggle--on\'}} {{if @disabled \'bb-toggle--disabled\'}} {{if @flat \'bb-toggle--flat\'}}\"\n>\n  {{! header row: label/hint + switch — the only clickable part, so a yielded\n      block below it stays interactive }}\n  <div\n    class=\"bb-toggle__head\"\n    role=\"switch\"\n    aria-checked=\"{{if @value \'true\' \'false\'}}\"\n    tabindex=\"{{if @disabled \'-1\' \'0\'}}\"\n    {{on \"click\" this.toggle}}\n    {{on \"keydown\" this.handleKey}}\n  >\n    <div class=\"bb-toggle__body\">\n      <p class=\"bb-toggle__label\">{{@label}}</p>\n      {{#if @hint}}\n        <p class=\"bb-toggle__hint\">{{@hint}}</p>\n      {{/if}}\n    </div>\n    <button\n      type=\"button\"\n      class=\"bb-toggle__switch {{if @value \'is-on\'}}\"\n      tabindex=\"-1\"\n      aria-hidden=\"true\"\n    >\n      <div class=\"bb-toggle__knob\"></div>\n    </button>\n  </div>\n\n  {{! revealed content — sits inside the toggle when it is on }}\n  {{#if (and @value (has-block))}}\n    <div class=\"bb-toggle__content\">\n      {{yield}}\n    </div>\n  {{/if}}\n</div>\n");

var _class;
let BbToggle = (_class = class BbToggle extends Component {
  toggle() {
    if (!this.args.disabled) {
      this.args.onChange?.(!this.args.value);
    }
  }
  handleKey(e) {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      this.toggle();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "toggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKey"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbToggle);

export { BbToggle as default };
//# sourceMappingURL=bb-toggle.js.map
